/**
 * Utility functions for extracting and processing table data from extraction results
 */

/**
 * Extract tables from extraction result - include both combined and individual tables
 * @param {Object} extractionResult - The extraction result from the API
 * @returns {Array} Array of tables with separators
 */
export const extractTablesFromResult = (extractionResult) => {
  const allTables = [];

  // Add combined tables first (if available)
  const combinedTables = extractionResult?.data?.combined_tables;
  if (combinedTables && combinedTables.length > 0) {
    allTables.push(...combinedTables);
  }

  // Add individual tables
  const individualTables =
    extractionResult?.data?.table_processing_result?.merged_tables || [];
  if (individualTables.length > 0) {
    // Add a separator if we have both combined and individual tables
    if (allTables.length > 0) {
      allTables.push({ isSeparator: true });
    }
    allTables.push(...individualTables);
  }

  return allTables;
};
